import { AdminDiscountCode } from "@workspace/admin-domain/src/features/discount-code/schema";
import { t } from "i18next";
import * as z from "zod";

export const DISCOUNT_CODE_SORT_OPTIONS: {
  label: string;
  kv: `${AdminDiscountCode["SortBy"]}_${AdminDiscountCode["SortOrder"]}`;
  value: {
    key: AdminDiscountCode["SortBy"];
    order: AdminDiscountCode["SortOrder"];
  };
}[] = [
  {
    label: t("discountCodes.sort.code_asc"),
    kv: "code_asc",
    value: { key: "code", order: "asc" },
  },
  {
    label: t("discountCodes.sort.code_desc"),
    kv: "code_desc",
    value: { key: "code", order: "desc" },
  },
  {
    label: t("discountCodes.sort.type_asc"),
    kv: "type_asc",
    value: { key: "type", order: "asc" },
  },
  {
    label: t("discountCodes.sort.type_desc"),
    kv: "type_desc",
    value: { key: "type", order: "desc" },
  },
  {
    label: t("discountCodes.sort.usageLimit_asc"),
    kv: "usageLimit_asc",
    value: { key: "usageLimit", order: "asc" },
  },
  {
    label: t("discountCodes.sort.usageLimit_desc"),
    kv: "usageLimit_desc",
    value: { key: "usageLimit", order: "desc" },
  },
  {
    label: t("discountCodes.sort.expiresAt_asc"),
    kv: "expiresAt_asc",
    value: { key: "expiresAt", order: "asc" },
  },
  {
    label: t("discountCodes.sort.expiresAt_desc"),
    kv: "expiresAt_desc",
    value: { key: "expiresAt", order: "desc" },
  },
  {
    label: t("discountCodes.sort.newOnly_asc"),
    kv: "newOnly_asc",
    value: { key: "newOnly", order: "asc" },
  },
  {
    label: t("discountCodes.sort.newOnly_desc"),
    kv: "newOnly_desc",
    value: { key: "newOnly", order: "desc" },
  },
  {
    label: t("discountCodes.sort.createdAt_asc"),
    kv: "createdAt_asc",
    value: { key: "createdAt", order: "asc" },
  },
  {
    label: t("discountCodes.sort.createdAt_desc"),
    kv: "createdAt_desc",
    value: { key: "createdAt", order: "desc" },
  },
] as const;

export const DEFAULT_DISCOUNT_CODES_PARAMS = {
  page: 0,
  limit: 10,
  sortBy: "createdAt",
  sortOrder: "desc",
} satisfies AdminDiscountCode["GetAll"];

export const DiscountCodeFiltersSchema = AdminDiscountCode.GetAll.partial({
  page: true,
  limit: true,
  sortBy: true,
  sortOrder: true,
});
export type DiscountCodeFiltersSchema = z.infer<typeof DiscountCodeFiltersSchema>;
